import styled from 'styled-components';
import { ModalFeatureDemandStyled } from '../../ModalFeatureDemandStyled';
import { rem } from 'polished';

export const ModalFeatureDemandStyledOV = styled(ModalFeatureDemandStyled)`
    
`;
